// @ts-check
import { Line, LineChart, Tooltip, XAxis, YAxis } from 'recharts';
import BlockCard from '../BlockCard';
import { formatRupees } from '../../../utils/wholesale';

/** Daily paid-revenue line for the range, with the change on the previous equal period (an em dash when there was none). */
export default function RevenueBlock({ block }) {
  const { total = 0, delta_pct: delta = null, daily = [] } = block.data || {};
  const rounded = delta === null || delta === undefined ? null : Math.round(delta);

  return (
    <BlockCard title="Revenue" href={block.href} headline={block.headline && { ...block.headline, display: formatRupees(block.headline.value) }}>
      {total > 0 ? (
        <div data-testid="revenue-chart" className="overflow-x-auto">
          <LineChart width={320} height={120} data={daily} aria-hidden="true">
            <XAxis dataKey="date" hide />
            <YAxis hide domain={[0, 'auto']} />
            <Tooltip formatter={(v) => [formatRupees(v), 'Revenue']} />
            <Line type="monotone" dataKey="revenue" stroke="#3b82f6" strokeWidth={2} dot={false} isAnimationActive={false} />
          </LineChart>
        </div>
      ) : (
        <p className="text-sm text-muted-foreground">No revenue in this range</p>
      )}
      <p className="mt-2 text-sm text-muted-foreground" data-testid="revenue-delta">
        {rounded === null ? '—' : `${rounded > 0 ? '+' : ''}${rounded}%`} vs previous period
      </p>
    </BlockCard>
  );
}
